import { render, staticRenderFns } from "./CultureGrowthPhaseView.vue?vue&type=template&id=5994053c&scoped=true&"
import script from "./CultureGrowthPhaseView.vue?vue&type=script&lang=js&"
export * from "./CultureGrowthPhaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5994053c",
  null
  
)

export default component.exports